<script>
    import {homeURL} from "../store.js";
    window.location.redirect(`${homeURL}`);
</script>

<style lang="scss">
</style>
